import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IFormComponent, ItemType } from "../entitybuilder/edit-entity.component";

@Component({
    templateUrl: "./array-form.component.html",
    standalone: false
})

export class ArrayFormComponent implements IFormComponent {
    @Input() title: string;
    @Input() data: any;
    @Input() parent?: string;
    @Input() formComponent: FormGroup;
    @Input() newItem?: boolean;
    itemTypes:Array<ItemType> = [
        { key: "String", value: "string" },
        { key: "Array", value: "array" },
        { key: "Bool", value: "boolean" },
        { key: "Object", value: "object" },
        { key: "Number", value: "number" },
        { key: "Integer", value: "integer"}
    ];

    get name() { return this.formComponent.get("name"); }
    get allowNulls() { return this.formComponent.get("allowNulls"); }
    get itemType() { return this.formComponent.get("itemType"); }

}



